import { useMemo } from 'react'
import { useAuth } from '@/contexts/AuthContext'

export function useAdmin() {
  const { accountData } = useAuth()

  // Memoize the results to prevent unnecessary recalculations
  const { isAdmin, isLoading } = useMemo(() => {
    if (!accountData) {
      return { isAdmin: false, isLoading: true }
    }

    return {
      isAdmin: accountData.is_admin === true,
      isLoading: false,
    }
  }, [accountData])

  return { isAdmin, isLoading }
}
